(function () {

  function initShopByCollection(section) {

    if (!section) return;


    const tabs = section.querySelectorAll('.sbc__tab');

    const collections = section.querySelectorAll('.sbc__collection');


    /* =====================================================
       COLLECTION TABS
    ===================================================== */

    tabs.forEach((tab) => {

      tab.addEventListener('click', function () {

        const index = this.dataset.collectionIndex;


        /* Update tabs */

        tabs.forEach((item) => {

          item.classList.remove('is-active');

          item.setAttribute(
            'aria-selected',
            'false'
          );

        });


        this.classList.add('is-active');

        this.setAttribute(
          'aria-selected',
          'true'
        );


        /* Update collections */

        collections.forEach((collection) => {

          const isActive =
            collection.dataset.collection === index;


          if (isActive) {

            collection.hidden = false;

            collection.classList.add('is-active');

          } else {

            collection.hidden = true;

            collection.classList.remove('is-active');

          }

        });

      });

    });


    /* =====================================================
       CAROUSEL
    ===================================================== */

    collections.forEach((collection) => {

      const track =
        collection.querySelector('.sbc__track');

      const prev =
        collection.querySelector('.sbc__arrow--prev');

      const next =
        collection.querySelector('.sbc__arrow--next');


      if (!track) return;


      const getScrollAmount = () => {

        const product =
          track.querySelector('.sbc__product');

        if (!product) return 300;


        const styles =
          window.getComputedStyle(track);

        const gap =
          parseFloat(styles.columnGap) || 0;


        return product.offsetWidth + gap;

      };


      if (prev) {

        prev.addEventListener('click', () => {

          track.scrollBy({

            left: -getScrollAmount(),

            behavior: 'smooth'

          });

        });

      }


      if (next) {

        next.addEventListener('click', () => {

          track.scrollBy({

            left: getScrollAmount(),

            behavior: 'smooth'

          });

        });

      }

    });

  }


  /* =====================================================
     INITIALIZE
  ===================================================== */

  function init() {

    document
      .querySelectorAll('.sbc')
      .forEach(initShopByCollection);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /* =====================================================
     SHOPIFY THEME EDITOR
  ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector('.sbc');

      if (section) {

        initShopByCollection(section);

      }

    }
  );

})();